import isEmpty from "lodash.isempty";

const checkACL = function(menuKey) {
  let userInfo = (localStorage.getItem("userInfo")) ? JSON.parse(localStorage.getItem("userInfo")) : [];
  if(userInfo.userTypeName =='subadmin' || [1, 2, 4, 5, 6, 7, 8, 9].includes(parseInt(localStorage.getItem('userTypeID'))) == false){
    return (userInfo.user_permissions.indexOf(menuKey) >= 0) ? true : false;
  }
  else
  {
    return true;
  }
}

const isMenuAccessible = function(menuKey, aclLists) {
  return true;
}

const isPrimaryMenuAccessible = function(menuKey, menuType) {
  let userTypeName = localStorage.getItem("userTypeName");
  let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
  if(userTypeName == 'subadmin'){
    if(menuKey =='DASHBOARD'){
      return true;
    }else if(menuKey =='ANNOUNCEMENTS_LIST' && siteData.activeSubadmin == 'Active'){
      return true;
    }
    else
    {
      let userInfo = (localStorage.getItem("userInfo")) ? JSON.parse(localStorage.getItem("userInfo")) : [];
      if(isEmpty(userInfo.user_permissions)){
        return false;
      }
      else
      {
        if(!isEmpty(menuType) && menuType=='parent')
        {
          if(!isEmpty(aclUtil[menuKey])){
            let found = userInfo.user_permissions.some(r=> aclUtil[menuKey].includes(r));
            return found;
          }
        }
        else
        {
          return (userInfo.user_permissions.indexOf(menuKey) >= 0) ? true : false;
        }
      }
    }
  }
  else if(userTypeName == 'merchant'){
    if(menuKey =='DASHBOARD'){
      return true;
    }else if(menuKey =='ANNOUNCEMENTS_LIST'){
      let status = siteData.activeMerchant == 'In-Active' ? 'false' : 'true';
      return status;
    }
    else
    {
      let userInfo = (localStorage.getItem("userInfo")) ? JSON.parse(localStorage.getItem("userInfo")) : [];
      if(isEmpty(userInfo.user_permissions)){
        return false;
      }
      else
      {
        if(!isEmpty(menuType) && menuType=='parent')
        {
          if(!isEmpty(aclUtil[menuKey])){
            let found = userInfo.user_permissions.some(r=> aclUtil[menuKey].includes(r));
            return found;
          }
        }
        else
        {
          return (userInfo.user_permissions.indexOf(menuKey) >= 0) ? true : false;
        }
      }
    }
  }
  else if([1, 2].includes(parseInt(localStorage.getItem('userTypeID'))) == false){
    if(menuKey =='DASHBOARD'){
      return true;
    }else if(menuKey =='ANNOUNCEMENTS_LIST' && (siteData.activeAnnouncementsAll == 'Active' || siteData.activeMerchant == 'Active' || siteData.activeSubadmin == 'Active')){
      return true;
    }
    else
    {
      let userInfo = (localStorage.getItem("userInfo")) ? JSON.parse(localStorage.getItem("userInfo")) : [];
      if(isEmpty(userInfo.user_permissions)){
        return false;
      }
      else
      {
        if(!isEmpty(menuType) && menuType=='parent')
        {
          if(!isEmpty(aclUtil[menuKey])){
            let found = userInfo.user_permissions.some(r=> aclUtil[menuKey].includes(r));
            return found;
          }
        }
        else
        {
          return (userInfo.user_permissions.indexOf(menuKey) >= 0) ? true : false;
        }
      }
    }
  }
  else
  {
    return true;
  }
}

const merchantCreateMenu = ['ADD_MERCHANT']
const merchantViewMenu = ['LIST_MERCHANT', 'VIEW_MERCHANT', 'ARCHIVE_MERCHANT', 'EDIT_MERCHANT', 'W9INFO'];
const merchantMenu = [...merchantCreateMenu, ...merchantViewMenu]; 

const offerCreateMenu = ['ADD_CONTRACT'];
const contractMenu = ['LIST_CONTRACT', 'VIEW_CONTRACT', 'DELETE_CONTRACT', 'EDIT_CONTRACT', 'EXECUTE_CONTRACT'];
const viewOfferMenu = ['VIEW_OFFERS', 'EDIT_OFFER', 'DELETE_OFFER', 'VIEW_LEAD'];
const offerMenu = [...offerCreateMenu, ...contractMenu, ...viewOfferMenu];

const viewProductMenu = ['ADD_PRODUCTS', 'EDIT_PRODUCTS'];
const productMenu = ['VIEW_PRODUCTS', 'EDIT_PRODUCTS_OFFER', 'PUBLISH_PRODUCTS'];
const productsMenu = [...viewProductMenu, ...productMenu];

const viewAuctionMenu = ['ADD_AUCTIONS', 'EDIT_AUCTIONS'];
const auctionMenu = ['VIEW_AUCTIONS', 'EDIT_AUCTIONS_OFFER', 'PUBLISH_AUCTIONS'];
const auctionsMenu = [...viewAuctionMenu, ...auctionMenu];

const emailManagerMenu = ['LIST_COMPAIGN', 'IMPORT_SUBSCRIBER', 'EXPORT_SUBSCRIBER','LIST_MARKET', 'LIST_POSTUP'];
const promoCodeMenu = ['LIST_PROMO_CODE', 'ADD_PROMO_CODE', 'DELETE_PROMO_CODE', 'EDIT_PROMO_CODE'];
const affiliatMenu = ['LIST_AFFILIATE', 'ADD_AFFILIATE', 'VIEW_AFFILIATE', 'DELETE_AFFILIATE', 'EDIT_AFFILIATE']
const storeMenu = ['STORES'];
const marketingMenu = [...emailManagerMenu, ...promoCodeMenu, ...affiliatMenu, ...storeMenu];

const generalMenu = ['GENERAL_SEARCH'];
const voucherMenu = ['LIST_VOUCHERS', 'GENERATE_VOUCHER', 'CHANGE_STATUS', 'EDIT_VOUCHER', 'TRANSFER_VOUCHER', 'REFUND_VOUCHER'];
const searchMenu = [...generalMenu, ...voucherMenu]; 

const buyersMenu = ['BUYER_METRICS', 'COUPONOFFERS_REPORT', 'DEALBUYER_REPORT', 'SUBSCRIBERS_REPORT']; 
const commissionsMenu = ['AFFILIATE_COMMISSION', 'EMPLOYEE_COMISSIONS']; 
const merchantPayMenu = ['MERCHANT_PAYOUTS', 'MERCHANT_PAID_PAYOUTS', 'PAY_ON_REDEMPTION', 'MERCHANT_PAYOUT_BY_OFFER'];
const revenueMenu = ['NET_REVENUE_REPORTS', 'REVENUE_REPORTS'];  
const salesMenu = ['INVENTORY_REPORT', 'REFUNDS_REPORT', 'SALES_BY_OFFER', 'SALESOVERVIEW_REPORT', 'SALES_PERFORMANCE', 'SALES_REPORT', 'TRANSACTION_REPORT','REFUNDS_ARCHIVE_REPORT','PROMO_CODE_REPORT' ]; 

const reportMenu = [...buyersMenu, ...commissionsMenu, ...merchantPayMenu, ...revenueMenu, ...salesMenu];

const merchantPayout = ['MERCHANT_PAYOUTS', 'MERCHANT_PAID_PAYOUTS', 'PAY_ON_REDEMPTION', 'MERCHANT_PAYOUT_BY_OFFER']
const questionMenu = ['MANAGE_QUESTIONS', 'VIEW_QUESTION', 'GIVE_ANSWER', 'DELETE_QUESTION']
const reviewMenu = ['MANAGE_REVIEWS', 'EDIT_REVIEW', 'DELETE_REVIEW'];
const feedbackMenu = [...questionMenu, ...reviewMenu]; 

const settingMenu = ['EDIT_SITE', 'CITY_LISTING'];

const categoryMenu = ['LIST_CATEGORY', 'ADD_CATEGORY', 'VIEW_CATEGORY', 'DELETE_CATEGORY', 'EDIT_CATEGORY'];

const employeeMenu = ['LIST_EMPLOYEE', 'ADD_EMPLOYEE', 'VIEW_EMPLOYEE', 'DELETE_EMPLOYEE', 'EDIT_EMPLOYEE', 'MANAGE_ACL', 'MANAGE_ROLES'];

const roleMenu = ['MANAGE_ROLES', 'LIST_ROLES', 'ADD_ROLE', 'EDIT_ROLE', 'DELETE_ROLE'];


const assetMenu = ['LIST_ASSET', 'ADD_ASSET', 'DELETE_ASSET', 'EDIT_ASSET'];

const assetColorMenu = ['LIST_ASSET_COLOR', 'ADD_ASSET_COLOR', 'DELETE_ASSET_COLOR', 'EDIT_ASSET_COLOR'];

const faqMenu = ['LIST_FAQ', 'ADD_FAQ', 'DELETE_FAQ', 'EDIT_FAQ', 'VIEW_FAQ'];

const designCenterMenu = ['PAGE_TEMPLATE', 'EMAIL_TEMPLATE', 'EDIT_EMAIL_TEMPLATE', ...assetMenu, ...assetColorMenu, ...faqMenu];

const cherityMenu = ['CHARITY_ADD', 'CHARITY_LIST'];

const siteSettingMenu = [...cherityMenu, ...settingMenu, ...categoryMenu, ...employeeMenu, ...designCenterMenu, ...roleMenu];

const paymentsMenu = ['PAYMENT_SETTING','PAYMENT_TERMS'];

const apiseomainMenu = ['API_SETTINGS','SEO_SETTINGS','MAINTENANCE_MODE','ACCOUNT_SETTINGS','CITY_PASSWORDS'];

const formSettingMenu = ['FORM_SETTINGS'];

const formMerchantDashboard = ['MERCHANT_DASHBOARD_DEAL_BUYER_LIST'];

const announcementsMenu = ['ANNOUNCEMENTS_LIST'];



export const aclUtil = {
  checkACL,
  isMenuAccessible,
  isPrimaryMenuAccessible,
  voucherMenu,
  merchantMenu,
  offerMenu,
  productsMenu,
  auctionsMenu,
  marketingMenu,
  searchMenu,
  reportMenu,
  feedbackMenu,
  siteSettingMenu,
  questionMenu,
  reviewMenu,
  designCenterMenu,
  faqMenu,
  assetColorMenu,
  assetMenu,
  employeeMenu,
  paymentsMenu,
  apiseomainMenu,
  merchantPayout,
  emailManagerMenu,
  cherityMenu,
  formSettingMenu,
  formMerchantDashboard,
  announcementsMenu
}



// WEBPACK FOOTER //
// ./src/app/views/util.js